const SET_DASHBOARD_AOL = 'dashboard/SET_AOL'

const initialState = {
  aol: null
}

export default function dashboardReducer (state = initialState, action) {
  switch (action.type) {
    case SET_DASHBOARD_AOL:
      return { ...state, aol: action.aol }
    default:
      return state
  }
}
